import { Injectable } from '@angular/core';
import { IFileManagerModalContext, IListItemQueryResult } from '../models/interface';
import { IFileManagerModalResult, FileManagerModal } from '../components/file-manager-modal/FileManagerModal';
import { Observable } from 'rxjs';
import { FuiModalService } from 'ngx-fomantic-ui';

@Injectable({
  providedIn: 'root'
})
export class FileManagerModalService {

  constructor(private modal: FuiModalService) { }

  open(context: IFileManagerModalContext) {
    return new Observable<IListItemQueryResult | IListItemQueryResult[]>((o) => {
      this.modal.open(new FileManagerModal(context))
      .onApprove((result: IFileManagerModalResult) => {
        o.next(result);
        o.complete();
      })
      .onDeny(() => {
        o.error();
        o.complete();
      });
    });
  }
}
